module.exports = __webpack_public_path__ + "img/akkoMain.d03cf75b.png";